export default __webpack_public_path__ + "static/media/hotel_1.259edb50.png";